// @ts-nocheck — TODO: tipizzare quando si tocca
// ====== Backup & Restore ======
// Interfaccia con le RPC Supabase definite in seed/backup-schema.sql
// I backup vivono su Postgres (tabella public.backups, colonna jsonb).
// Le RPC sono `security definer`: validano via utenti_portale che l'utente sia admin.

let _backupsCache = [];

const backupApi = {
  // Crea un backup. source: 'manual' | 'auto' (auto in genere lo gestisce pg_cron).
  async create(source, notes) {
    const { data, error } = await sb.rpc('create_backup', {
      p_source: source || 'manual',
      p_notes: notes || ''
    });
    if (error) throw error;
    return data; // uuid
  },

  async list() {
    const { data, error } = await sb.rpc('list_backups');
    if (error) throw error;
    return data || [];
  },

  async getPayload(id) {
    const { data, error } = await sb.rpc('get_backup_payload', { p_id: id });
    if (error) throw error;
    return data;
  },

  async remove(id) {
    const { error } = await sb.rpc('delete_backup', { p_id: id });
    if (error) throw error;
  },

  async restore(id) {
    const { data, error } = await sb.rpc('restore_backup', { p_backup_id: id });
    if (error) throw error;
    return data;
  }
};

function formatBytes(n) {
  if (n == null) return '—';
  if (n < 1024) return n + ' B';
  if (n < 1024 * 1024) return (n / 1024).toFixed(1) + ' KB';
  return (n / 1024 / 1024).toFixed(2) + ' MB';
}

function backupSourceLabel(source) {
  if (source === 'manual') return '<span class="backup-tag manual">Manuale</span>';
  if (source === 'auto') return '<span class="backup-tag auto">Automatico</span>';
  if (source === 'pre_restore') return '<span class="backup-tag pre">Pre-ripristino</span>';
  return `<span class="backup-tag">${escapeHtml(source)}</span>`;
}

function backupCountsSummary(counts) {
  if (!counts) return '';
  const order = [
    'clienti',
    'risorse',
    'accessi',
    'contratti',
    'referenti',
    'documenti',
    'scadenze',
    'audit_log',
    'utenti_portale',
    'persone_interne',
    'todos',
    'ruoli_predefiniti',
    'user_preferences',
    'notifications'
  ];
  const parts = order
    .filter((k) => counts[k] != null)
    .map((k) => `${counts[k]} ${k.replace(/_/g, ' ')}`);
  return parts.join(' · ');
}

async function renderBackups() {
  if (!isAdmin()) return;
  const tbody = $('#tbodyBackups');
  if (!tbody) return;

  tbody.innerHTML =
    '<tr><td colspan="6" style="text-align:center;padding:20px;color:var(--text-muted)">Caricamento…</td></tr>';

  try {
    _backupsCache = await backupApi.list();
  } catch (e) {
    console.error('Errore lista backup', e);
    const msg =
      (e.message || '').toLowerCase().includes('does not exist') || e.code === '42883'
        ? 'Le funzioni di backup non risultano installate. Esegui <code>seed/backup-schema.sql</code> nel SQL Editor di Supabase.'
        : 'Errore caricamento backup: ' + (e.message || e);
    tbody.innerHTML = `<tr><td colspan="6" style="text-align:center;padding:20px;color:var(--danger)">${msg}</td></tr>`;
    return;
  }

  const lastAuto = _backupsCache.find((b) => b.source === 'auto');
  const lastAutoEl = $('#backupLastAuto');
  if (lastAutoEl) {
    lastAutoEl.textContent = lastAuto
      ? `Ultimo backup automatico: ${fmtDateTime(lastAuto.created_at)}`
      : 'Nessun backup automatico ancora generato.';
  }

  if (!_backupsCache.length) {
    tbody.innerHTML =
      '<tr><td colspan="6" style="text-align:center;padding:30px;color:var(--text-muted)">Nessun backup presente.</td></tr>';
    return;
  }

  tbody.innerHTML = _backupsCache
    .map(
      (b) => `
    <tr data-bid="${escapeHtml(b.id)}">
      <td data-label="Quando">${escapeHtml(fmtDateTime(b.created_at))}</td>
      <td data-label="Tipo">${backupSourceLabel(b.source)}</td>
      <td data-label="Creato da">${escapeHtml(b.created_by_name || '—')}</td>
      <td data-label="Dimensione">${formatBytes(b.size_bytes)}</td>
      <td data-label="Contenuto" class="muted" style="font-size:11px;">${escapeHtml(backupCountsSummary(b.row_counts))}</td>
      <td class="user-actions">
        <button class="btn btn-sm" data-act="download"><svg class="btn-svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v12"/><polyline points="7 10 12 15 17 10"/><path d="M5 21h14"/></svg>Scarica</button>
        <button class="btn btn-sm" data-act="restore"><svg class="btn-svg" viewBox="0 0 24 24" aria-hidden="true"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>Ripristina</button>
        <button class="btn btn-sm btn-danger" data-act="delete">Elimina</button>
      </td>
    </tr>
  `
    )
    .join('');

  tbody.querySelectorAll('tr[data-bid]').forEach((tr) => {
    const id = tr.dataset.bid;
    tr.querySelector('[data-act="download"]').addEventListener('click', () => downloadBackup(id));
    tr.querySelector('[data-act="restore"]').addEventListener('click', () => restoreBackup(id));
    tr.querySelector('[data-act="delete"]').addEventListener('click', () => deleteBackup(id));
  });
}

async function createManualBackup() {
  if (!isAdmin()) return;
  const btn = $('#btnBackupNow');
  const originalHtml = btn ? btn.innerHTML : '';
  if (btn) {
    btn.disabled = true;
    btn.textContent = 'Creazione…';
  }
  try {
    const id = await backupApi.create('manual', '');
    logAudit({
      action: 'create',
      entity: 'Backup',
      target: 'Snapshot',
      details: 'Backup manuale creato'
    });
    toast('Backup creato');
    await renderBackups();
    return id;
  } catch (e) {
    console.error(e);
    toast('Errore creazione backup: ' + (e.message || e));
  } finally {
    if (btn) {
      btn.disabled = false;
      btn.innerHTML = originalHtml;
    }
  }
}

async function downloadBackup(id) {
  if (!isAdmin()) return;
  try {
    const payload = await backupApi.getPayload(id);
    if (!payload) {
      toast('Backup vuoto o non leggibile');
      return;
    }
    const meta = _backupsCache.find((b) => b.id === id);
    const ts = (meta?.created_at || new Date().toISOString()).replace(/[:.]/g, '-').slice(0, 19);
    const tag = meta?.source || 'backup';
    downloadFile(
      `portale-mase-${tag}-${ts}.json`,
      JSON.stringify(payload, null, 2),
      'application/json'
    );
    toast('Backup scaricato');
  } catch (e) {
    console.error(e);
    toast('Errore download: ' + (e.message || e));
  }
}

async function downloadCurrentSnapshot() {
  // Esporta lo stato corrente (senza passare dalla tabella backups)
  // Usa la RPC build_snapshot per avere TUTTI i dati (audit completo incluso).
  if (!isAdmin()) return;
  try {
    const { data, error } = await sb.rpc('build_snapshot');
    if (error) throw error;
    const ts = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
    downloadFile(
      `portale-mase-export-${ts}.json`,
      JSON.stringify(data, null, 2),
      'application/json'
    );
    toast('Esportazione completata');
  } catch (e) {
    console.error(e);
    // Fallback: esporta lo state in memoria (audit limitato a 500 voci)
    const ts = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
    downloadFile(
      `portale-mase-export-${ts}.json`,
      JSON.stringify(state, null, 2),
      'application/json'
    );
    toast('Esportato stato locale (RPC non disponibile)');
  }
}

async function deleteBackup(id) {
  if (!isAdmin()) return;
  const b = _backupsCache.find((x) => x.id === id);
  if (!b) return;
  const ok = await confirmAction({
    level: 'warning',
    title: 'Eliminare backup',
    message: `Stai per eliminare il backup del ${fmtDateTime(b.created_at)}.`,
    details: [
      `Tipo: ${b.source === 'manual' ? 'Manuale' : b.source === 'auto' ? 'Automatico' : 'Pre-ripristino'}`,
      `Creato da: ${b.created_by_name || '—'}`,
      `Dimensione: ${formatBytes(b.size_bytes)}`
    ],
    warning: 'Operazione irreversibile.',
    confirmText: 'Elimina backup'
  });
  if (!ok) return;
  try {
    await backupApi.remove(id);
    logAudit({
      action: 'delete',
      entity: 'Backup',
      target: fmtDateTime(b.created_at),
      details: `Backup ${b.source} eliminato`
    });
    toast('Backup eliminato');
    await renderBackups();
  } catch (e) {
    console.error(e);
    toast('Errore eliminazione: ' + (e.message || e));
  }
}

async function restoreBackup(id) {
  if (!isAdmin()) return;
  const b = _backupsCache.find((x) => x.id === id);
  if (!b) return;
  const ok = await confirmAction({
    level: 'danger',
    title: 'Ripristinare il portale a questo backup?',
    message: `Tutti i dati attuali (clienti, accessi, contratti, scadenze, storico) verranno sostituiti con quelli del ${fmtDateTime(b.created_at)}.`,
    details: [
      `Backup ${b.source === 'manual' ? 'manuale' : 'automatico'} di ${fmtDateTime(b.created_at)}`,
      `Contiene: ${backupCountsSummary(b.row_counts)}`,
      'Prima del ripristino verrà creato automaticamente uno snapshot dello stato attuale',
      'Gli utenti del portale (sicurezza) NON vengono toccati per evitare lockout'
    ],
    warning:
      'Operazione molto invasiva. Tutti gli utenti collegati vedranno i nuovi dati al prossimo refresh.',
    confirmText: 'Ripristina',
    requireType: 'RIPRISTINA'
  });
  if (!ok) return;
  const btnRow = document.querySelector(`tr[data-bid="${id}"]`);
  if (btnRow) btnRow.querySelectorAll('button').forEach((b) => (b.disabled = true));
  try {
    const result = await backupApi.restore(id);
    // Ricarica lo stato in memoria
    await loadStateFromSupabase();
    logAudit({
      action: 'system',
      entity: 'Backup',
      target: 'Ripristino',
      details: `Ripristinato backup ${id}. Pre-restore: ${result?.pre_restore_id || '—'}`
    });
    if (typeof notifyCritical === 'function')
      notifyCritical('backup.restored', {
        restored_id: id,
        pre_restore_id: result?.pre_restore_id
      });
    renderAll();
    setView('dashboard');
    toast('Ripristino completato');
    await renderBackups();
  } catch (e) {
    console.error(e);
    toast('Errore ripristino: ' + (e.message || e));
    if (btnRow) btnRow.querySelectorAll('button').forEach((b) => (b.disabled = false));
  }
}

// Fallback client-side: se all'login dell'admin non c'è un backup automatico recente
// (>26h fa), ne crea uno. Garanzia se pg_cron non fosse attivo o fosse fallito.
async function ensureRecentAutoBackup() {
  if (!isAdmin()) return;
  try {
    const list = await backupApi.list();
    const lastAuto = list.find((b) => b.source === 'auto');
    const stale =
      !lastAuto || Date.now() - new Date(lastAuto.created_at).getTime() > 26 * 60 * 60 * 1000;
    if (stale) {
      console.info('Backup automatico più vecchio di 26h — creo snapshot di sicurezza');
      await backupApi.create('auto', 'Backup automatico (fallback client)');
    }
  } catch (e) {
    // Silenzioso: se le RPC non esistono ancora (migration non eseguita) non rompiamo il login
    console.warn('ensureRecentAutoBackup skipped:', e.message || e);
  }
}

// ===== Backup completo scaricabile (con allegati) =====
// Elenco ricorsivo di tutti i file in un bucket Storage.
async function listAllStorageFiles(bucket, prefix = '') {
  const out = [];
  const { data, error } = await sb.storage.from(bucket).list(prefix, { limit: 1000 });
  if (error || !data) return out;
  for (const item of data) {
    const path = prefix ? `${prefix}/${item.name}` : item.name;
    if (item.id || item.metadata) out.push(path);
    else out.push(...(await listAllStorageFiles(bucket, path)));
  }
  return out;
}

// Scarica un archivio .zip con TUTTI i dati (dati.json) + i file allegati.
async function downloadFullBackupZip() {
  if (!isAdmin()) return;
  toast('Preparazione archivio completo… attendi qualche secondo');
  try {
    const { data: snapshot, error } = await sb.rpc('build_snapshot');
    if (error) throw error;
    const { default: JSZip } = await import('jszip');
    const zip = new JSZip();
    zip.file('dati.json', JSON.stringify(snapshot, null, 2));
    let nFiles = 0;
    for (const bucket of ['documenti', 'todo-attachments']) {
      let paths = [];
      try {
        paths = await listAllStorageFiles(bucket);
      } catch (_) {
        paths = [];
      }
      for (const path of paths) {
        try {
          const { data: blob, error: dErr } = await sb.storage.from(bucket).download(path);
          if (dErr || !blob) continue;
          zip.file(`allegati/${bucket}/${path}`, blob);
          nFiles++;
        } catch (_) {
          /* salta i file problematici */
        }
      }
    }
    const out = await zip.generateAsync({ type: 'blob' });
    const ts = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
    const url = URL.createObjectURL(out);
    const a = document.createElement('a');
    a.href = url;
    a.download = `portale-mase-backup-completo-${ts}.zip`;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 3000);
    toast(`Backup completo scaricato (${nFiles} file allegati inclusi)`);
  } catch (e) {
    console.error(e);
    toast('Errore backup completo: ' + (e.message || e));
  }
}

// ===== Azzeramento totale dei dati (tranne gli amministratori) =====
async function wipeAllData() {
  if (!isAdmin()) return;
  const nClienti = (state?.clients || []).length;
  const nRisorse = (state?.resources || []).length;
  const ok = await confirmAction({
    level: 'danger',
    title: 'Svuotare TUTTI i dati del portale?',
    message: 'Stai per cancellare definitivamente tutti i dati. Verranno eliminati:',
    details: [
      `${nClienti} clienti e ${nRisorse} risorse`,
      'Tutti gli accessi, contratti, referenti, documenti e file allegati',
      'Tutte le scadenze e lo storico delle modifiche',
      'Rubrica persone interne, attività, catalogo ruoli e preferenze',
      'Tutti gli utenti TRANNE gli amministratori'
    ],
    warning:
      'Prima di cancellare viene creato in automatico un backup completo di sicurezza. Operazione irreversibile: si torna indietro solo ripristinando quel backup.',
    confirmText: 'Continua',
    cancelText: 'Annulla',
    requireType: 'CANCELLA TUTTO'
  });
  if (!ok) return;
  const ok2 = await confirmAction({
    level: 'danger',
    title: 'Ultima conferma',
    message: 'Confermi l’azzeramento totale? Dopo questa conferma non si torna indietro.',
    details: ['Il backup di sicurezza viene creato automaticamente subito prima.'],
    confirmText: 'Sì, azzera tutto ora',
    cancelText: 'No, annulla'
  });
  if (!ok2) return;

  const btn = $('#btnWipeAll');
  const original = btn ? btn.innerHTML : '';
  if (btn) {
    btn.disabled = true;
    btn.textContent = 'Azzeramento in corso…';
  }
  try {
    const { data, error } = await sb.rpc('wipe_all_data');
    if (error) throw error;
    // I file allegati nello Storage si cancellano dal client (la cancellazione via
    // SQL è vietata da Supabase): elenco e rimuovo tutti i file dei due bucket.
    for (const bucket of ['documenti', 'todo-attachments']) {
      try {
        const paths = await listAllStorageFiles(bucket);
        if (paths.length) await sb.storage.from(bucket).remove(paths);
      } catch (_) {
        /* best-effort: i riferimenti nel DB sono comunque già stati cancellati */
      }
    }
    await loadStateFromSupabase();
    renderAll();
    setView('dashboard');
    toast(
      `Dati azzerati. Backup di sicurezza creato. Utenti rimossi: ${data?.deleted_users ?? 0}.`
    );
    if (typeof renderBackups === 'function') renderBackups();
  } catch (e) {
    console.error(e);
    toast('Errore azzeramento: ' + (e.message || e));
  } finally {
    if (btn) {
      btn.disabled = false;
      btn.innerHTML = original;
    }
  }
}

// ===== Event listeners =====
document.addEventListener('DOMContentLoaded', () => {
  const btnNow = document.getElementById('btnBackupNow');
  if (btnNow) btnNow.addEventListener('click', createManualBackup);

  const btnSnapshot = document.getElementById('btnDownloadSnapshot');
  if (btnSnapshot) btnSnapshot.addEventListener('click', downloadCurrentSnapshot);

  const btnRefresh = document.getElementById('btnBackupsRefresh');
  if (btnRefresh) btnRefresh.addEventListener('click', renderBackups);

  const btnZip = document.getElementById('btnDownloadFullZip');
  if (btnZip) btnZip.addEventListener('click', downloadFullBackupZip);

  const btnWipe = document.getElementById('btnWipeAll');
  if (btnWipe) btnWipe.addEventListener('click', wipeAllData);
});

Object.assign(globalThis, {
  backupApi,
  renderBackups,
  createManualBackup,
  downloadBackup,
  downloadCurrentSnapshot,
  downloadFullBackupZip,
  wipeAllData,
  listAllStorageFiles,
  deleteBackup,
  restoreBackup,
  ensureRecentAutoBackup
});
export {};
